import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "task-management" }
const _hoisted_2 = { class: "task-toolbar" }
const _hoisted_3 = { class: "task-range" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "admin-section" }
const _hoisted_6 = {
  key: 0,
  class: "admin-loading"
}
const _hoisted_7 = {
  key: 1,
  class: "admin-stats admin-stats--compact"
}
const _hoisted_8 = {
  key: 0,
  class: "admin-section"
}
const _hoisted_9 = { class: "admin-stats admin-stats--compact" }
const _hoisted_10 = { class: "admin-stat admin-stat--compact" }
const _hoisted_11 = { class: "admin-stat admin-stat--compact" }
const _hoisted_12 = { class: "admin-stat admin-stat--compact" }
const _hoisted_13 = { class: "admin-stat admin-stat--compact" }
const _hoisted_14 = { class: "admin-section" }
const _hoisted_15 = { class: "task-filter" }
const _hoisted_16 = { class: "task-filter__field" }
const _hoisted_17 = { class: "task-filter__field" }
const _hoisted_18 = { class: "task-filter__field" }
const _hoisted_19 = { class: "task-filter__field" }
const _hoisted_20 = { class: "task-filter__field" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "task-filter__field" }
const _hoisted_23 = { class: "task-table" }
const _hoisted_24 = ["title"]
const _hoisted_25 = ["title"]
const _hoisted_26 = ["title"]
const _hoisted_27 = ["title"]
const _hoisted_28 = { class: "task-cell" }
const _hoisted_29 = { class: "task-cell" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "task-cell task-quality-cell" }
const _hoisted_32 = ["title"]
const _hoisted_33 = { class: "task-diagnostics" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["title"]
const _hoisted_37 = ["title"]
const _hoisted_38 = { class: "task-cell" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = ["title"]
const _hoisted_42 = { class: "task-pagination" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogViewerModal = _resolveComponent("LogViewerModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[19] || (_cache[19] = _createElementVNode("h2", null, "任务质量指标", -1)),
        _createElementVNode("p", null, _toDisplayString(_ctx.rangeHint) + "，任务列表保留全量分页，指标按区间筛选。", 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presets, (preset) => {
          return (_openBlock(), _createElementBlock("button", {
            key: preset.days,
            type: "button",
            class: _normalizeClass(['task-range__preset', { 'task-range__preset--active': _ctx.selectedPreset === preset.days }]),
            onClick: ($event: any) => (_ctx.applyPreset(preset.days))
          }, _toDisplayString(preset.label), 11, _hoisted_4))
        }), 128)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
          type: "date",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedPreset = 0))
        }, null, 544), [
          [_vModelText, _ctx.startDate]
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("span", null, "至", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDate) = $event)),
          type: "date",
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedPreset = 0))
        }, null, 544), [
          [_vModelText, _ctx.endDate]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "task-range__apply",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.loadMetrics && _ctx.loadMetrics(...args)))
        }, "应用")
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      (_ctx.outcomeLoading || _ctx.reworkLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "加载中..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskMetrics, (metric) => {
              return (_openBlock(), _createElementBlock("article", {
                key: metric.label,
                class: "admin-stat admin-stat--compact"
              }, [
                _createElementVNode("strong", null, _toDisplayString(metric.value), 1),
                _createElementVNode("span", null, _toDisplayString(metric.label), 1)
              ]))
            }), 128))
          ]))
    ]),
    (_ctx.outcome && Object.keys(_ctx.outcome.byMode).length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
          _cache[25] || (_cache[25] = _createElementVNode("h2", null, "按模式拆分", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outcome.byMode, (stats, mode) => {
            return (_openBlock(), _createElementBlock("div", {
              key: mode,
              class: "task-mode-group"
            }, [
              _createElementVNode("h3", null, _toDisplayString(mode), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("article", _hoisted_10, [
                  _createElementVNode("strong", null, _toDisplayString(stats.total), 1),
                  _cache[21] || (_cache[21] = _createElementVNode("span", null, "总数", -1))
                ]),
                _createElementVNode("article", _hoisted_11, [
                  _createElementVNode("strong", null, _toDisplayString(stats.completed), 1),
                  _cache[22] || (_cache[22] = _createElementVNode("span", null, "成功", -1))
                ]),
                _createElementVNode("article", _hoisted_12, [
                  _createElementVNode("strong", null, _toDisplayString(stats.failed), 1),
                  _cache[23] || (_cache[23] = _createElementVNode("span", null, "失败", -1))
                ]),
                _createElementVNode("article", _hoisted_13, [
                  _createElementVNode("strong", null, _toDisplayString(stats.cancelled), 1),
                  _cache[24] || (_cache[24] = _createElementVNode("span", null, "取消", -1))
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_14, [
      _cache[35] || (_cache[35] = _createElementVNode("h2", null, "任务列表", -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("label", _hoisted_16, [
          _cache[26] || (_cache[26] = _createElementVNode("span", null, "开始", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterStartDate) = $event)),
            type: "date"
          }, null, 512), [
            [_vModelText, _ctx.filterStartDate]
          ])
        ]),
        _createElementVNode("label", _hoisted_17, [
          _cache[27] || (_cache[27] = _createElementVNode("span", null, "结束", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterEndDate) = $event)),
            type: "date"
          }, null, 512), [
            [_vModelText, _ctx.filterEndDate]
          ])
        ]),
        _createElementVNode("label", _hoisted_18, [
          _cache[28] || (_cache[28] = _createElementVNode("span", null, "标题", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterTitle) = $event)),
            type: "text",
            placeholder: "按标题模糊搜索",
            onKeyup: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.applyTaskFilter && _ctx.applyTaskFilter(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.filterTitle]
          ])
        ]),
        _createElementVNode("label", _hoisted_19, [
          _cache[29] || (_cache[29] = _createElementVNode("span", null, "创建人", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filterCreator) = $event)),
            type: "text",
            placeholder: "邮箱/昵称",
            onKeyup: _cache[10] || (_cache[10] = _withKeys(
//@ts-ignore
(...args) => (_ctx.applyTaskFilter && _ctx.applyTaskFilter(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.filterCreator]
          ])
        ]),
        _createElementVNode("label", _hoisted_20, [
          _cache[31] || (_cache[31] = _createElementVNode("span", null, "状态", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filterStatus) = $event))
          }, [
            _cache[30] || (_cache[30] = _createElementVNode("option", { value: "" }, "全部", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (s) => {
              return (_openBlock(), _createElementBlock("option", {
                key: s,
                value: s
              }, _toDisplayString(s), 9, _hoisted_21))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.filterStatus]
          ])
        ]),
        _createElementVNode("label", _hoisted_22, [
          _cache[32] || (_cache[32] = _createElementVNode("span", null, "模式", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filterMode) = $event)),
            type: "text",
            placeholder: "按模式模糊搜索",
            onKeyup: _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => (_ctx.applyTaskFilter && _ctx.applyTaskFilter(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.filterMode]
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "task-filter__btn task-filter__btn--primary",
          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.applyTaskFilter && _ctx.applyTaskFilter(...args)))
        }, "查询"),
        _createElementVNode("button", {
          type: "button",
          class: "task-filter__btn",
          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.resetTaskFilter && _ctx.resetTaskFilter(...args)))
        }, "重置")
      ]),
      _createElementVNode("table", _hoisted_23, [
        _cache[33] || (_cache[33] = _createElementVNode("colgroup", null, [
          _createElementVNode("col", { class: "task-col-title" }),
          _createElementVNode("col", { class: "task-col-creator" }),
          _createElementVNode("col", { class: "task-col-status" }),
          _createElementVNode("col", { class: "task-col-mode" }),
          _createElementVNode("col", { class: "task-col-pages" }),
          _createElementVNode("col", { class: "task-col-retail" }),
          _createElementVNode("col", { class: "task-col-progress" }),
          _createElementVNode("col", { class: "task-col-quality" }),
          _createElementVNode("col", { class: "task-col-created" }),
          _createElementVNode("col", { class: "task-col-download" }),
          _createElementVNode("col", { class: "task-col-error" })
        ], -1)),
        _cache[34] || (_cache[34] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "标题"),
            _createElementVNode("th", null, "创建人"),
            _createElementVNode("th", null, "状态"),
            _createElementVNode("th", null, "模式"),
            _createElementVNode("th", null, "预留/退款/净扣"),
            _createElementVNode("th", null, "零售价值"),
            _createElementVNode("th", null, "进度"),
            _createElementVNode("th", null, "质量"),
            _createElementVNode("th", null, "创建时间"),
            _createElementVNode("th", null, "PPTX"),
            _createElementVNode("th", null, "失败原因(管理)")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (task) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: task.id
            }, [
              _createElementVNode("td", {
                class: "task-cell",
                title: task.title || task.id
              }, _toDisplayString(task.title || task.id), 9, _hoisted_24),
              _createElementVNode("td", {
                class: "task-cell",
                title: _ctx.creatorLabel(task)
              }, _toDisplayString(_ctx.creatorLabel(task)), 9, _hoisted_25),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(['task-status', `task-status--${task.status}`])
                }, _toDisplayString(task.status), 3)
              ]),
              _createElementVNode("td", {
                class: "task-cell",
                title: task.mode
              }, _toDisplayString(task.mode), 9, _hoisted_26),
              _createElementVNode("td", {
                class: "task-cell",
                title: `${task.reserved_pages}/${task.refunded_pages}/${task.net_charged_pages}`
              }, _toDisplayString(task.reserved_pages) + "/" + _toDisplayString(task.refunded_pages) + "/" + _toDisplayString(task.net_charged_pages), 9, _hoisted_27),
              _createElementVNode("td", _hoisted_28, "¥" + _toDisplayString(task.retail_value_yuan.toFixed(2)), 1),
              _createElementVNode("td", _hoisted_29, [
                _createTextVNode(_toDisplayString(task.progress) + "% ", 1),
                (task.worker_attempts)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_30, " · " + _toDisplayString(task.worker_attempts) + "/" + _toDisplayString(task.max_worker_attempts || '-') + " 次", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_31, [
                _createElementVNode("span", null, "v" + _toDisplayString(task.quality_threshold_version || '-'), 1),
                (_ctx.qualityFailureText(task))
                  ? (_openBlock(), _createElementBlock("small", {
                      key: 0,
                      title: _ctx.qualityFailureText(task)
                    }, _toDisplayString(_ctx.qualityFailureText(task)), 9, _hoisted_32))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diagnosticButtons(task), (artifact) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: artifact.label,
                      type: "button",
                      onClick: ($event: any) => (_ctx.downloadDiagnostic(task, artifact))
                    }, _toDisplayString(artifact.label), 9, _hoisted_34))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logButtons(task), (log) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: log.label,
                      type: "button",
                      onClick: ($event: any) => (_ctx.openLog(task, log))
                    }, _toDisplayString(log.label), 9, _hoisted_35))
                  }), 128))
                ]),
                (_ctx.metricsSummary(task))
                  ? (_openBlock(), _createElementBlock("small", {
                      key: 1,
                      class: "task-metrics-line",
                      title: _ctx.metricsSummary(task)
                    }, _toDisplayString(_ctx.metricsSummary(task)), 9, _hoisted_36))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", {
                class: "task-cell",
                title: _ctx.formatDateTime(task.created_at)
              }, _toDisplayString(_ctx.formatDateTime(task.created_at)), 9, _hoisted_37),
              _createElementVNode("td", _hoisted_38, [
                (task.pptx_url)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "task-download",
                      onClick: ($event: any) => (_ctx.downloadTaskPptx(task))
                    }, "下载", 8, _hoisted_39))
                  : (_openBlock(), _createElementBlock("span", _hoisted_40, "-"))
              ]),
              _createElementVNode("td", {
                class: "task-cell task-error-cell",
                title: task.error_admin || ''
              }, _toDisplayString(task.error_admin || '-'), 9, _hoisted_41)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("button", {
          disabled: _ctx.page <= 1,
          onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.page--; _ctx.loadTasks()})
        }, "上一页", 8, _hoisted_43),
        _createElementVNode("span", null, _toDisplayString(_ctx.page) + " / " + _toDisplayString(Math.ceil(_ctx.total / _ctx.pageSize) || 1), 1),
        _createElementVNode("button", {
          disabled: _ctx.page * _ctx.pageSize >= _ctx.total,
          onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.page++; _ctx.loadTasks()})
        }, "下一页", 8, _hoisted_44)
      ])
    ]),
    (_ctx.logViewer)
      ? (_openBlock(), _createBlock(_component_LogViewerModal, {
          key: 1,
          viewer: _ctx.logViewer,
          onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.logViewer = null))
        }, null, 8, ["viewer"]))
      : _createCommentVNode("", true)
  ]))
}